import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ClientsQuery, Project, ProjectsQuery } from "@timeghost/web-api";
@Pipe({
	name: "defaultEntityTranslate",
})
export class DefaultEntityTranslatePipe implements PipeTransform {
	constructor(
		private projectQuery: ProjectsQuery,
		private clientQuery: ClientsQuery,
		private translate: TranslateService
	) {}
	transform(
		_entity: { id: string; name: string; useAsDefault?: boolean },
		_entityName: "project" | "client",
		_translateKey: string,
		_defaultValue: string = null,
		_useHtmlForExternalId: boolean = false
	): string {
		const entityQuery = _entityName === "project" ? this.projectQuery : this.clientQuery;
		if (!_entity) return _defaultValue;
		if (_entity.useAsDefault ?? !!entityQuery?.getEntity(_entity.id)?.useAsDefault)
			return this.encodeIfHtml(this.translate.instant(_translateKey), _useHtmlForExternalId);
		if (!_entity.name && _entityName === "project" && this.projectQuery.hasEntity(_entity.id))
			return this.encodeIfHtml(this.projectQuery.getEntity(_entity.id).name, _useHtmlForExternalId);
		if (_entityName === "project") {
			const storeProject = this.projectQuery.getEntity(_entity.id) as Project & { externalId?: string | null };
			const entityProject = _entity as Project & { externalId?: string | null };
			const name = storeProject?.name ?? entityProject.name;
			return this.encodeIfHtml(name, _useHtmlForExternalId);
		}
		return this.encodeIfHtml(_entity.name, _useHtmlForExternalId);
	}

	private encodeIfHtml(value: string, encode: boolean): string {
		return encode ? this.encode(value) : value;
	}

	private encode(value: string): string {
		if (!value) return "";
		return value
			.replace(/&/g, "&amp;")
			.replace(/</g, "&lt;")
			.replace(/>/g, "&gt;")
			.replace(/"/g, "&quot;")
			.replace(/'/g, "&#39;");
	}
}
